// getters
const academicAttendant = state => state.academicAttendant

export default {
    academicAttendant
}



// WEBPACK FOOTER //
// ./src/store/modules/academic/attendant/getters.js